import { LoyaltyCardType } from 'components/Loyalty/types'
import { LoyaltyMultiplierCard } from './types'

/** Either card shape the form deals with: Context (`LoyaltyCardType`, snake_case) or the get response (`LoyaltyMultiplierCard`, camelCase) */
export type SelectedMultiplierCard = LoyaltyCardType | LoyaltyMultiplierCard

const hasProductVariantIds = (
  card: SelectedMultiplierCard
): card is LoyaltyCardType => 'product_variant_ids' in card

/** Context wins when present, as it's fresher; the get response's card is the fallback for one archived since creation */
export const resolveSelectedCard = (
  cardId: string | undefined,
  loyaltyCards: LoyaltyCardType[],
  cardsLoading: boolean,
  isCreate: boolean,
  archivedCard?: LoyaltyMultiplierCard
): SelectedMultiplierCard | undefined => {
  const contextCard = loyaltyCards.find((card) => card.id === cardId)
  if (contextCard) return contextCard
  return !isCreate && !cardsLoading && archivedCard ? archivedCard : undefined
}

/** Normalises `stamp_type` (Context) / `stampType` (get response) into one check */
export const getStampType = (
  card?: SelectedMultiplierCard
): string | null | undefined =>
  card
    ? hasProductVariantIds(card)
      ? card.stamp_type
      : card.stampType
    : undefined

/** Normalises `stamp_label` (Context) / `stampLabel` (get response) into one check */
export const getStampLabel = (
  card?: SelectedMultiplierCard | null
): string | null | undefined =>
  card
    ? hasProductVariantIds(card)
      ? card.stamp_label
      : card.stampLabel
    : undefined

/** Narrows to a Context card; a card only the get response has was archived since creation */
export const asContextCard = (
  card?: SelectedMultiplierCard
): LoyaltyCardType | undefined =>
  card && hasProductVariantIds(card) ? card : undefined
